import { Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import './App.css';
// @ts-ignore — AuthContext es .jsx, Vite lo resuelve en build
import { AuthProvider } from '@/contexts/AuthContext';
import { InstrumentProvider } from './contexts/InstrumentContext';
import { PracticeModeProvider } from './contexts/PracticeModeContext';
import { GuitarInputProvider } from './contexts/GuitarInputContext';
import WelcomePage from './pages/Welcome';
import { RoleSelectorPage } from './pages/RoleSelector';
import { TaskViewPage } from './pages/TaskView';
import HomePage from './pages/Home';
import ExploreHubPage from './pages/ExploreHub';
import LearnHubPage from './pages/LearnHub';
import BeginnerPathPage from './pages/BeginnerPath';
import PlayHubPage from './pages/PlayHub';
import ClassroomsPage from './pages/Classrooms';
import ClassroomDetailPage from './pages/ClassroomDetail';
import DashboardPage from './pages/Dashboard';
import SongLibraryPage from './pages/SongLibrary';
import SongStudioPage from './pages/SongStudio';
import SongbookPage from './pages/SongbookPage';
import ScaleHubPage from './pages/ScaleHub';
import ScalePathPage from './pages/ScalePathPage';
import RhythmPathPage from './pages/RhythmPathPage';
import ChordPathPage from './pages/ChordPathPage';
import ScaleExplorerPage from './pages/ScaleExplorer';
import ModoExplorerPage from './pages/ModoExplorer';
import NotasExplorerPage from './pages/NotasExplorer';
import ChordHubPage from './pages/ChordHub';
import ChordBuilderPage from './pages/ChordBuilder';
import MelodyPracticePage from './pages/MelodyPractice';
import BordonaGymPage from './pages/BordonaGym';
import InstrumentPickerPage from './pages/InstrumentPicker';
import { RequireInstrumentSession } from './components/RequireInstrumentSession';
import PracticeSessionPage from './pages/PracticeSession';
import NotFound from './pages/NotFound';

export default function BordonaApp() {
  return (
    <AuthProvider>
      <PracticeModeProvider>
        <GuitarInputProvider>
        <InstrumentProvider>
          <Routes>
            <Route path="/" element={<RoleSelectorPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/instrument" element={<InstrumentPickerPage />} />
            <Route path="/task" element={<RequireInstrumentSession><TaskViewPage /></RequireInstrumentSession>} />
            <Route path="/task/:code" element={<RequireInstrumentSession><TaskViewPage /></RequireInstrumentSession>} />
            <Route path="/practice" element={<RequireInstrumentSession><PracticeSessionPage /></RequireInstrumentSession>} />
            <Route path="/home" element={<RequireInstrumentSession><HomePage /></RequireInstrumentSession>} />
            <Route path="/explore" element={<RequireInstrumentSession><ExploreHubPage /></RequireInstrumentSession>} />
            <Route path="/learn" element={<RequireInstrumentSession><LearnHubPage /></RequireInstrumentSession>} />
            <Route path="/learn/path" element={<RequireInstrumentSession><BeginnerPathPage /></RequireInstrumentSession>} />
            <Route path="/learn/scales" element={<RequireInstrumentSession><ScalePathPage /></RequireInstrumentSession>} />
            <Route path="/learn/rhythm" element={<RequireInstrumentSession><RhythmPathPage /></RequireInstrumentSession>} />
            <Route path="/learn/chords" element={<RequireInstrumentSession><ChordPathPage /></RequireInstrumentSession>} />
            <Route path="/play" element={<RequireInstrumentSession><PlayHubPage /></RequireInstrumentSession>} />
            <Route path="/clases" element={<RequireInstrumentSession><ClassroomsPage /></RequireInstrumentSession>} />
            <Route path="/clases/:code" element={<RequireInstrumentSession><ClassroomDetailPage /></RequireInstrumentSession>} />
            <Route path="/dashboard" element={<RequireInstrumentSession><DashboardPage /></RequireInstrumentSession>} />
            <Route path="/songs" element={<RequireInstrumentSession><SongLibraryPage /></RequireInstrumentSession>} />
            <Route path="/songs/:id" element={<RequireInstrumentSession><SongStudioPage /></RequireInstrumentSession>} />
            <Route path="/songbook" element={<RequireInstrumentSession><SongbookPage /></RequireInstrumentSession>} />
            <Route path="/scales" element={<RequireInstrumentSession><ScaleHubPage /></RequireInstrumentSession>} />
            <Route path="/scales/learn" element={<RequireInstrumentSession><ScalePathPage /></RequireInstrumentSession>} />
            <Route path="/scales/explorer" element={<RequireInstrumentSession><ScaleExplorerPage /></RequireInstrumentSession>} />
            <Route path="/modos" element={<RequireInstrumentSession><ModoExplorerPage /></RequireInstrumentSession>} />
            <Route path="/notas" element={<RequireInstrumentSession><NotasExplorerPage /></RequireInstrumentSession>} />
            <Route path="/chords" element={<RequireInstrumentSession><ChordHubPage /></RequireInstrumentSession>} />
            <Route path="/chords/explorer" element={<RequireInstrumentSession><ChordBuilderPage /></RequireInstrumentSession>} />
            <Route path="/melodies" element={<RequireInstrumentSession><MelodyPracticePage /></RequireInstrumentSession>} />
            <Route path="/fingers" element={<RequireInstrumentSession><BordonaGymPage /></RequireInstrumentSession>} />
            <Route path="/piano" element={<Navigate to="/scales" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </InstrumentProvider>
        </GuitarInputProvider>
      </PracticeModeProvider>
    </AuthProvider>
  );
}

